import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";

export const upperMaterialOptions = {
	LEATHER: { name: "LEATHER", key: "LEATHER" },
	NON_LEATHER: { name: "NON-LEATHER", key: "NON-LEATHER" },
};

export const upperMaterialColumn = {
	name: "Upper Material",
	key: "upper_material",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	constraints: { NOTNULL: true, DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list: Object.values(upperMaterialOptions),
	},
};

export const upperMaterialTypeOptions = [
	{ name: "GENUINE LEATHER", key: "GENUINE LEATHER", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "SUEDE", key: "SUEDE", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "HALF SUEDE", key: "HALF SUEDE", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "RARE LEATHER", key: "RARE LEATHER", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "SUEDE AND TEXTILE", key: "SUEDE AND TEXTILE", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "SUEDE AND FLYKNIT", key: "SUEDE AND FLYKNIT", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "MICROFIBRE", key: "MICROFIBRE", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "TEXTILE AND FLYKNIT", key: "TEXTILE AND FLYKNIT", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "SYNTHETIC MATERIAL", key: "SYNTHETIC MATERIAL", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "PARACHUTE", key: "PARACHUTE", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "CANVAS", key: "CANVAS", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
];

export const upperMaterialPatternOptions = [
	{ name: "SOLID", key: "SOLID", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "WOVEN", key: "WOVEN", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "MILLED", key: "MILLED", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "PRINTED", key: "PRINTED", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "MESH", key: "MESH", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "PATENT", key: "PATENT", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "SOLID", key: "SOLID", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "WOVEN", key: "WOVEN", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "MILLED", key: "MILLED", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "PRINTED", key: "PRINTED", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "MESH", key: "MESH", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
];

export const soleMaterialOptions = [
	{ name: "TPR", key: "TPR", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "TPU", key: "TPU", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "T-UNIT", key: "T-UNIT", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "EVA", key: "EVA", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "RUBBER", key: "RUBBER", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "LEATHER", key: "LEATHER", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "PVC", key: "PVC", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "WOOD", key: "WOOD", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "TPR", key: "TPR", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "TPU", key: "TPU", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "T-UNIT", key: "T-UNIT", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "EVA", key: "EVA", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "RUBBER", key: "RUBBER", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "PVC", key: "PVC", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "WOOD", key: "WOOD", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
];

export const insocksOptions = [
	{ name: "PU", key: "PU", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "MEMORY FORM", key: "MEMORY FORM", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "LEATHER", key: "LEATHER", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "ORTHOLITE", key: "ORTHOLITE", [upperMaterialColumn.key]: upperMaterialOptions.LEATHER.key },
	{ name: "PU", key: "PU", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "MEMORY FORM", key: "MEMORY FORM", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "LEATHER", key: "LEATHER", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
	{ name: "ORTHOLITE", key: "ORTHOLITE", [upperMaterialColumn.key]: upperMaterialOptions.NON_LEATHER.key },
];

export const footwearMaterialColumns = {
	fw_material_code: {
		name: "FW Material Code",
		key: "fw_material_code",
		input_type: inputTypes.AUTO_GENERATE.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	upper_material_type: {
		name: "Upper Material Type",
		key: "upper_material_type",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	upper_material_pattern: {
		name: "Upper Material Pattern",
		key: "upper_material_pattern",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	sole_material: {
		name: "Sole Material",
		key: "sole_material",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
	insocks: {
		name: "Insocks",
		key: "insocks",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
		[selectOptionsKeyName]: {
			type: arrType,
			list: [],
		},
	},
};
